// Copyright (c) 2017 Deere & Company

import BusyCounter, {getDefaultState as getBusyCounterDefaultState} from '../../../shared/state/busy-counter';
import Claims, {getDefaultState as getClaimsDefaultState} from './claims';
import CreateClaimModalType, {getDefaultState as getCreateClaimModalTypeDefaultState} from '../../../shared/state/create-claim-modal';
import SearchFilters from '../../../shared/state/search-filters';
import {getDefaultState as getSearchFiltersDefaultState} from './search-filters';
import t from 'tcomb';

const State = t.struct({
    busyCounter: BusyCounter,
    claims: Claims,
    createClaimModal: CreateClaimModalType,
    searchFilters: SearchFilters,
    selectedStatus: t.String
}, {
    name: 'State',
    strict: true
});

export const getDefaultState = () =>
    new State({
        busyCounter: getBusyCounterDefaultState(),
        claims: getClaimsDefaultState(),
        createClaimModal: getCreateClaimModalTypeDefaultState(),
        searchFilters: getSearchFiltersDefaultState(),
        selectedStatus: '1'
    });

export default State;



// WEBPACK FOOTER //
// ./src/claim/claims-in-progress/state/index.js